import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";
import Plus from '@assets/svg/plus.svg';
import {colors} from '@styles/colors';

export const SearchContainer = styled.div`
    margin-left:auto;
    height:32px;
    width:350px;
    position: relative;
`;

export const Cross = styled(Plus)`
  transform: rotate(45deg);
  transform-origin: center;

  path {
    fill: #acacac;
  }
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 42px;
  top: 5px;
  width: 16px;
  height: 16px;
`;

export const SearchBar = styled.div`
    background:#fff;
    display:flex;
    margin-left:auto;
    height:32px;
    border:1px solid #acacac;
    border-radius: 5px;
    z-index: 5;
    position: relative;

    input{
        width:calc(100% - 33px);
        height:30px;
        font-size: 14px;
        padding-left: 1.2rem;
        border-radius: 5px;
        border:none;
        outline:none;
        color:#696969;

        &::placeholder{
            color:#bebebe;
        }
    }

    button:nth-child(2){
        margin-right: -1px;
        display:flex;
        align-items:center;
        justify-content: center;
        height:30px;
        width:34px;
        border-radius: 0 5px 5px 0;
        background:#acacac;
        svg{
            height:18px;
            path{
                fill:#fff;
            }
        }
    }
    
`;


export const SearchResult = styled.div<{show?:boolean}>`
    display: ${props => props.show?"block":"none"};
    position: absolute;
    top:0;
    left:0;
    width:100%;
    border:1px solid #acacac;
    background:#fff;
    border-radius: 5px 5px 5px 5px;
    padding: 36px 0 0 0 ;
    z-index: 2;
    overflow: hidden;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
`;

export const ResultContent = styled.div`
    width:100%;
    max-height: 300px;
    overflow-y: auto;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    scrollbar-width: thin;

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background-color: #d8d8d8;
    }
    ::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    }
`;

export const ResultItem = styled.div`
    display:flex;
    align-items: center;
    gap:0.8rem;
    padding:0.5rem 1rem;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    
    &:hover{
        background:#ebebeb;
    }
`;

export const ResultImage = styled.div`
    height:30px;
    width:30px;
    position: relative;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
    border-radius: 5px;
    overflow: hidden;
    display:flex;
    align-items: center;
    justify-content: center;
    background:#2A848E;


    svg{
        height:12px;
        path{
            fill:#fff;
        }
    }
`;

export const ResultInfo = styled.div`
    display:flex;
    flex-direction: column;

`;

export const Title = styled.div`
    font-weight: 500;
    line-height: 16px;
    color:#696969;
`;

export const Type = styled.div`
    font-size: 10px;
    line-height: 14px;
`;